import { authHeader } from '../../_helpers';
import axios from 'axios';

export const workSheetService = {
    createApiService,
    orientationApiService,
    getWorksheetHandler,
    saveWorksheetHandler,
    shareWorksheetHandler,
    removeSharingWorksheetHandler,
    updateWorksheetHandler,
    getSharedUsersHandler,
    saveCommentHandler,
    getCommentListHandler,
    getWorkSheetDetailsHandler,
    getSharedWithUsersHandler,
    getWeakAreaHandler,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')




function createApiService(data) {
    return axios.post(`/assessments/goal-setting/worksheets/create/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function orientationApiService(data) {
    return axios.post(`/masters/instrument/orientation/list/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function getWorksheetHandler(id) {
    return axios.get(`/assessments/goal-setting/worksheets/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function saveWorksheetHandler(data) {
    return axios.put(`/assessments/goal-setting/worksheets/attributes/update/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function shareWorksheetHandler(data) {
    return axios.post(`/assessments/goal-setting/worksheets/share/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function removeSharingWorksheetHandler(data) {
    return axios.post(`/assessments/goal-setting/worksheets/remove-share/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function updateWorksheetHandler(data) {
    return axios.put(`/assessments/goal-setting/worksheets/update/${data.id}/?access_token=${token}`, data.data)
        .then(response => {
            return response;
        });
}

function getSharedUsersHandler() {
    return axios.get(`/assessments/goal-setting/worksheets/sharedwithme/?access_token=${token}`)
        .then(response => {
            return response;
        });

}

function saveCommentHandler(commentValue) {
    return axios.post(`/assessments/goal-setting/worksheets/comment/create/?access_token=${token}`, commentValue)
        .then(response => {
            return response;
        });
}

function getCommentListHandler(id) {
    return axios.get(`/assessments/goal-setting/worksheets/comment/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getWorkSheetDetailsHandler(data) {
    const fd = {
        'worksheet_id': data
    }
    return axios.post(`/assessments/goal-setting/worksheets/attributes/list/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getSharedWithUsersHandler(id) {
    return axios.get(`/assessments/goal-setting/worksheets/shared_with/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getWeakAreaHandler(data) {

    const fd = {
        'user_assessment': data.assessment,
        'orientation_id': data.orientation_id,
    }
    return axios.post(`/assessments/goal-setting/worksheets/weaksection/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/workSheet/workSheet.service.js